module.exports = __webpack_public_path__ + "static/media/29COICT10.344a073c.jpg";